
import ConfigListTreeParser from '../helpers/ConfigListTreeParser'
import type {ConfigversionsInfo} from '@/types'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
const _ = require("lodash")

@Component({
  computed: {
    ...mapGetters({
      getConfigurationsList: 'getConfigurationsList',
      getConfigsListNodesMap: 'getConfigsListNodesMap',
      getDarkMode: 'getDarkMode',
      getDBNames: 'getDBNames',
    }),
  },
  methods: {
    ...mapActions({
      fetchDBNames: 'fetchDBNames',
      fetchCfgFromServerByName: 'fetchCfgFromServerByName',
      setSnackBarText: 'setSnackBarText',
      fetchConfigurationList: 'fetchConfigurationList',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      clearStoreState: 'clearStoreState',
      setConfigsListLoaded: 'setConfigsListLoaded',
      setInitialConfigsIDCounter: 'setInitialConfigsIDCounter',
      createConfigsListNodesMap: 'createConfigsListNodesMap',
    }),
  },
})
export default class OpenRemoteConfigDialog extends Vue {
  @Prop(Boolean) dialogVisible!: boolean

  @Watch('dialogVisible')
  // eslint-disable-next-line no-unused-vars
  onDialogVisibleChanged(val: any, oldVal: any) {
    /*     console.log('active VAL:' + val)
    console.log('active OLDVAL: ' + oldVal) */
    //if (val) this.createConfigurationsList()
    if (val) this.createDBList()
  }

  @Watch('selectedDB')
  // eslint-disable-next-line no-unused-vars
  onDBChanged(val: any, oldVal: any) {
    console.log('active VAL:' + val)
    console.log('active OLDVAL: ' + oldVal)
    this.createConfigurationsList()
  }
  private dialogHeader: string = 'Open remote config'

  private getDarkMode!: boolean

  private configsListNodeMap!: Object //ID to Node Object map
  //private open: any = [1]
  private active: any = []
  private getDBNames!: Array<string>

  private idCounter = 1 //main config tree ID counter
  private dbItems: Array<string> = []
  private selectedDB: string = ''

  private loadingConfigs: boolean = false

  private headers: Array<Object> = [
    {
      text: 'Version',
      align: 'start',
      sortable: false,
      value: 'version',
    },
    { text: 'Created', value: 'created' },
    { text: 'Creator', value: 'creator' },
    { text: 'Release Tag', value: 'release' },
  ]
  private tableItems: Array<Object> = []
  private selected: Array<any> = []

  private search: any = null
  private caseSensitive: boolean = false

  //Vuex getters
  private getConfigurationsList!: any // are assigned via mapState
  private getConfigsListNodesMap!: any

  //Vuex actions
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private fetchCfgFromServerByName!: (payload: {
    cfg: string
    db: string
  }) => Promise<any>
  private fetchDBNames!: () => Promise<any>
  private fetchConfigurationList!: (payload: string) => Promise<any>
  private setStartLoadingConfig!: (payload: boolean) => Promise<any>
  private setConfigLoaded!: (payload: boolean) => Promise<any>
  private clearStoreState!: () => Promise<any>
  private setConfigsListLoaded!: (payload: boolean) => Promise<any>
  private setInitialConfigsIDCounter!: (payload: number) => Promise<any>
  private createConfigsListNodesMap!: (payload: Object) => Promise<any>

  get filter() {
    return this.caseSensitive
      ? (item, search, textKey) => {
          item[textKey].indexOf(search) > -1
        }
      : undefined
  }

  get items() {
    return [this.getConfigsListNodesMap[1]]
  }

  async createDBList(): Promise<void> {
    console.log('fetchDBList')

    Promise.all([await this.fetchDBNames()])
      .finally(() => {
        this.dbItems = this.getDBNames
      })
      .catch((error) => {
        this.setSnackBarText({
          snackBarText: error,
          snackBarColor: 'red',
        })
      })
  }

  async createConfigurationsList(): Promise<void> {
    //reset maps and ID counters
    this.configsListNodeMap = {}
    this.idCounter = 1
    this.loadingConfigs = true
    //let t0 = performance.now()
    this.setConfigsListLoaded(false)
    //this.$store.dispatch('clearStoreState')
    console.log('createConfigurationsList')
    Promise.all([await this.fetchConfigurationList(this.selectedDB)])
      .finally(async () => {
        let ret = ConfigListTreeParser.parseConfigs(
          this.getConfigurationsList,
          this.configsListNodeMap,
          this.idCounter
        )
        this.idCounter = ret['idCounter']

        /*      console.log(
        'topLevelNodeNameReferenceIDsMap: ' +
          JSON.stringify(this.topLevelNodeNameReferenceIDsMap)
      ) */
        //console.log('MAP2: ' + JSON.stringify(this.configsListNodeMap))

        this.createConfigsListNodesMap(this.configsListNodeMap)
        //initilaize id counter in the store so other components can get/modify it
        this.setInitialConfigsIDCounter(this.idCounter)
        this.setConfigsListLoaded(true)

        this.loadingConfigs = false

        //let t1 = performance.now()

        /*      this.$store.dispatch('setSnackBarText', {
        snackBarText:
          'Configuration successfully loaded! It took: ' +
          Math.round(t1 - t0) / 1000 +
          ' seconds',
        snackBarColor: 'green',
      }) */
      })
      .catch((error) => {
        this.setSnackBarText({
          snackBarText: error,
          snackBarColor: 'red',
        })
      })
  }

  public updateActiveNodes(array: any): void {
    //console.log('AAA')
    let difference: number = parseInt(
      this.active
        .filter((x) => !array.includes(x))
        .concat(array.filter((x) => !this.active.includes(x)))
    )
    if (array.length != 0) difference = array[0]
    if (Object.keys(this.getConfigsListNodesMap).length !== 0) {
      console.log(
        JSON.stringify(this.getConfigsListNodesMap[difference].versionsInfo)
      )
      this.tableItems = _.cloneDeep(this.getConfigsListNodesMap[difference].versionsInfo)      
      this.tableItems.sort((a: ConfigversionsInfo ,b : ConfigversionsInfo) => {
          //first entry is always V
          return parseInt(b.version.substring(1)) - parseInt(a.version.substring(1))

        }
      )
      
    }
    this.active = array
  }

  public openConfig() {
    
    console.log('SELECTED: ' + JSON.stringify(this.selected))
    if (this.selected.length == 0) {
      this.setSnackBarText({
        snackBarText: 'Choose the valid configuration first!',
        snackBarColor: 'red',
      })
      return false
    }
    this.$router.push({path: 'open', query : { cfg : this.selected[0]['path'], db : this.selectedDB} } ).then().catch(err => console.log(err))

    this.selected =  []
    //this.selectedDB = ''
    this.$emit('update:dialogVisible', false)
  }

  public closeDialog() {
    this.$emit('update:dialogVisible', false)
  }

  created() {
    //this.createConfigurationsList()
  }
  updated() {
    console.log("updated")
  }
}
